import { CSSProperties } from "react";

export const calculateDragConstraints = (
  panelWidth: number,
  panelHeight: number
) => ({
  left: -(window.innerWidth - panelWidth - 16),
  right: 16,
  top: -window.innerHeight / 2 + 16,
  bottom: window.innerHeight / 2 - panelHeight + 16,
});

export const calculatePanelStyle = (
  panelWidth: number,
  panelHeight: number,
  isOpen: boolean
): CSSProperties => ({
  position: "fixed" as const,
  top: "50%",
  right: 80,
  transform: "translateY(-50%)",
  zIndex: 50,
  width: panelWidth,
  maxWidth: window.innerWidth - 120,
  minWidth: 280,
  height: panelHeight,
  minHeight: 300,
  maxHeight: "70vh",
  overflow: "hidden" as const,
  display: !isOpen ? "none" : "flex",
  flexDirection: "column" as const,
  background: "#fff",
  boxShadow: "0 25px 50px -12px rgba(0,0,0,0.25)",
  borderRadius: 12,
});
